const Error = () => {
    return(
        <>
            <h4>ERROR</h4>
        </>
    );
}

export default Error;